// The tab's icon carries a red dot while DMs or mentions wait, as the
// title carries their count; it is drawn from the app's icon.

let plain: string | null = null;
let dotted: Promise<string> | null = null;

function link(): HTMLLinkElement | null {
  return document.querySelector<HTMLLinkElement>('link[rel="icon"]');
}

function draw(src: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const size = 64;
      const canvas = document.createElement("canvas");
      canvas.width = canvas.height = size;
      const g = canvas.getContext("2d");
      if (!g) return reject(new Error("no canvas"));
      g.drawImage(img, 0, 0, size, size);
      g.beginPath();
      g.arc(size * 0.76, size * 0.24, size * 0.2, 0, 2 * Math.PI);
      g.fillStyle = "#e01e5a";
      g.fill();
      g.lineWidth = size * 0.06;
      g.strokeStyle = "#fff";
      g.stroke();
      resolve(canvas.toDataURL("image/png"));
    };
    img.onerror = reject;
    img.src = src;
  });
}

// resetFavicon forgets the icon drawn on, after the logo changed.
export function resetFavicon() {
  plain = null;
  dotted = null;
  if (link()?.dataset.dot === "1") setFaviconDot(true);
}

// setFaviconDot puts the dot on the tab's icon, or takes it off.
export function setFaviconDot(on: boolean) {
  const el = link();
  if (!el) return;
  plain ??= el.href;
  if (!on) {
    el.href = plain;
    return;
  }
  dotted ??= draw(plain);
  dotted.then(
    (href) => {
      // Still waiting by the time it is drawn.
      if (link() === el && el.dataset.dot === "1") el.href = href;
    },
    () => {},
  );
  el.dataset.dot = "1";
}

export function clearFaviconDot() {
  const el = link();
  if (el) delete el.dataset.dot;
  setFaviconDot(false);
}
